import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

export const TONES = {
  red: { text: "text-red-300", dot: "bg-red-400", bar: "border-l-red-400", soft: "bg-red-500/10 border-red-400/30" },
  orange: { text: "text-amber-300", dot: "bg-amber-400", bar: "border-l-amber-400", soft: "bg-amber-500/10 border-amber-400/30" },
  cyan: { text: "text-cyan-300", dot: "bg-cyan-400", bar: "border-l-cyan-400", soft: "bg-cyan-400/10 border-cyan-400/30" },
  green: { text: "text-emerald-300", dot: "bg-emerald-400", bar: "border-l-emerald-400", soft: "bg-emerald-500/10 border-emerald-400/30" },
  grey: { text: "text-slate-400", dot: "bg-slate-500", bar: "border-l-slate-600", soft: "bg-white/[0.03] border-white/10" },
};

export const Panel = ({ title, icon: Icon, action, children, testid, className = "" }) => (
  <section className={`rounded-2xl border border-white/[0.07] bg-[#0F1F3D]/80 p-4 sm:p-5 ${className}`} data-testid={testid}>
    <div className="mb-4 flex items-center justify-between gap-3">
      <h2 className="flex items-center gap-2 font-display text-base font-semibold text-white md:text-lg">
        {Icon && <Icon className="h-4 w-4 text-cyan-300" />}{title}
      </h2>
      {action}
    </div>
    {children}
  </section>
);

export const PanelLink = ({ to, children, testid }) => (
  <Link to={to} data-testid={testid} className="inline-flex items-center gap-1 text-sm text-cyan-300 transition-colors hover:text-cyan-200">
    {children}<ChevronRight className="h-4 w-4" />
  </Link>
);

export const Kpi = ({ to, label, value, tone = "cyan", icon: Icon, testid }) => {
  const zero = !value;
  const t = TONES[zero ? "grey" : tone];
  return (
    <Link to={to} data-testid={testid}
      className="group flex min-h-[96px] flex-col justify-between rounded-xl border border-white/[0.07] bg-[#122549]/60 p-4 transition-colors duration-150 hover:border-cyan-400/40 hover:bg-[#122549]">
      <div className="flex items-center justify-between gap-2">
        <span className="text-sm leading-tight text-slate-300">{label}</span>
        {Icon && <Icon className={`h-4 w-4 shrink-0 ${t.text}`} />}
      </div>
      <span className={`font-display text-3xl font-semibold tabular-nums ${zero ? "text-slate-500" : "text-white"}`} data-testid={`${testid}-value`}>
        {value ?? "—"}
      </span>
    </Link>
  );
};
